@if (type === rowTypes.Audio) {
<div class="audio">
    <div
        class="audio__wrapper"
        [ngClass]="{'audio__wrapper--playing': audioPlaying}"
        (click)="handleClick()"
    >
        <ng-content select="bbvms-audio"></ng-content>
    </div>
</div>
} @if (type === rowTypes.Text) {
<div class="text">
    <div class="text__wrapper">
        <ng-content select="span"></ng-content>
    </div>
</div>
} @if (type === rowTypes.Image) {
<div class="image">
    <div class="image__wrapper">
        <ng-content select="img"></ng-content>
    </div>
</div>
}
<div class="content" [ngClass]="{'content--center': centerContent}">
    <ng-content></ng-content>
</div>
